/**
 * Whether the current URL may render without a full signed-in user (public shell).
 *
 * - `/open/movie/*` — SPA entry from movieShare redirect; public without query params.
 * - `/review/*` — resolver (Hosting → reviewShare CF for crawlers; in-app / SPA loads route).
 * - `/data-deletion` — public data-deletion instructions; same path shows full UI when signed in.
 * - Watchlist / profile / person — still use `?shared=true` (and optional `sharedBy`, etc.).
 * - `/movie/:id` — production Hosting calls movieShare CF; SPA rarely sees this without going through CF first.
 */
export function isSharedRoute(pathname: string, search: string): boolean {
  const searchParams = new URLSearchParams(search);
  const isShared = searchParams.get('shared') === 'true';

  if (/^\/open\/movie\/[^/]+\/?$/.test(pathname)) {
    return true;
  }

  if (/^\/review\/[^/]+\/?$/.test(pathname)) {
    return true;
  }

  if (/^\/data-deletion\/?$/.test(pathname)) {
    return true;
  }

  const sharedRoutePatterns = [
    /^\/movie\/[^/]+\/?$/,
    /^\/watchlist\/[^/]+\/?$/,
    /^\/profile\/[^/]+\/?$/,
    /^\/profile\/[^/]+\/reviews\/?$/,
    /^\/person\/[^/]+\/?$/,
  ];

  return isShared && sharedRoutePatterns.some((pattern) => pattern.test(pathname));
}
